var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14209_16320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.999 49.5833V56.6667H-0.000729166V49.5833C-0.000729166 30.0546 15.8872 14.1667 35.4159 14.1667H42.4993V7.08333C42.4993 3.17333 45.6726 0 49.5826 0C53.4926 0 56.6659 3.17333 56.6659 7.08333V14.1667H113.333V7.08333C113.333 3.17333 116.506 0 120.416 0C124.326 0 127.499 3.17333 127.499 7.08333V14.1667H134.583C154.111 14.1667 169.999 30.0546 169.999 49.5833ZM-0.000729166 134.583V70.8333H167.067L113.156 124.738C109.465 128.428 103.033 128.428 99.336 124.738L94.8451 120.24C85.7997 111.194 70.0322 111.194 60.9868 120.24L16.6309 164.595C6.64344 158.327 -0.0078125 147.213 -0.0078125 134.583H-0.000729166ZM21.2493 95.625C21.2493 101.49 26.0093 106.25 31.8743 106.25C37.7393 106.25 42.4993 101.49 42.4993 95.625C42.4993 89.76 37.7393 85 31.8743 85C26.0093 85 21.2493 89.76 21.2493 95.625ZM123.178 134.753C114.14 143.799 98.3726 143.799 89.3201 134.753L84.8293 130.255C81.1389 126.565 74.7001 126.565 71.0097 130.255L31.4847 169.773C32.7739 169.915 34.0843 169.993 35.4159 169.993H134.583C154.111 169.993 169.999 154.105 169.999 134.576V87.9254L123.178 134.753Z",
    fill: "#D8D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14209_16320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyClasses);
export default __webpack_public_path__ + "static/media/empty-classes.07a51c01d66e64544cb05e8d18483020.svg";
export { ForwardRef as ReactComponent };